import { resourceText } from 'src/app/shared/services/localization';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalService } from 'src/app/shared/services/global.service';
import { Location } from '@angular/common';

@Component({
    selector: 'app-unauthorized',
    templateUrl: './unauthorized.component.html',
    styleUrls: ['./unauthorized.component.scss'],
    standalone: false
})
export class UnauthorizedComponent implements OnInit, AfterViewInit {
  constructor(private _router: Router, private globalService: GlobalService, private _location: Location) {}

  ngOnInit(): void {}

  ngAfterViewInit() {
    setTimeout(() => {
    this.globalService.title.push(this.globalService.screenHeader);
    this.globalService.screenHeader = resourceText('NOTIFICATION');
    });
  }       
}
 